import {
  afterNextRender,
  computed,
  Directive,
  ElementRef,
  inject,
  input,
  OnDestroy,
  signal,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[appHeaderNavigationActive]',
  standalone: true,
})
export class AppHeaderNavigationActiveDirective implements OnDestroy {
  readonly appHeaderNavigationActive = input.required<string>();

  private readonly host = inject(ElementRef<HTMLAnchorElement>);
  private readonly router = inject(Router);
  private readonly currentUrl = signal(this.router.url);
  private readonly classObserver = new MutationObserver(() => {
    this.syncCurrentClass();
  });
  readonly isActive = computed(() => {
    const activeRoute = this.appHeaderNavigationActive();
    const currentUrl = this.currentUrl().split(/[?#]/)[0];
    return (
      currentUrl === activeRoute || currentUrl.startsWith(`${activeRoute}/`)
    );
  });

  constructor() {
    afterNextRender(() => {
      this.currentUrl.set(this.router.url);
      this.syncCurrentClass();
      this.classObserver.observe(this.host.nativeElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event) => {
        this.currentUrl.set(event.urlAfterRedirects);
        this.syncCurrentClass();
      });
  }

  ngOnDestroy(): void {
    this.classObserver.disconnect();
  }

  private syncCurrentClass(): void {
    const link = this.host.nativeElement;
    link.style.setProperty(
      '--goa-app-header-nav-active-indicator-color',
      'var(--goa-color-interactive-default)',
      'important'
    );
    link.classList.toggle('current', this.isActive());
  }
}
